import { render, staticRenderFns } from "./EnvelopeFilters.vue?vue&type=template&id=50a56abc&"
import script from "./EnvelopeFilters.vue?vue&type=script&lang=js&"
export * from "./EnvelopeFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports